import { $, $$ } from '@3pc/dom';
import Slider from 'modules/glide/glide';
import { ClickRedirect } from '@3pc/click-redirect';

const imageSliders = $$('.image-slider');

if (imageSliders.length) {
  imageSliders.forEach(imageSlider => {
    const items = $$('.image-slider__item', imageSlider);

    if (items.length > 1) {
      const slider = $('.glide', imageSlider);

      new Slider(slider, {
        config: {
          type: 'slider',
          rewind: false,
          controls: true,
          bullets: true,
          numeric: false,
          perView: 1,
          gap: 50,
          appendTarget: $('.glide__navigation__inner', imageSlider),
        },
      }).init();
    }
  });
}

const imageSlidersItems = $$('.image-slider__item');

if (imageSlidersItems.length) {
  imageSlidersItems.forEach(imageSlidersItem => {
    // Get references to the source and target elements
    const sourceElement = $('.image-slider__picture', imageSlidersItem);
    const targetElement = $('.image-slider__link', imageSlidersItem);

    if (!sourceElement || !targetElement) {
      return;
    }

    // Define configuration options
    const config = {
      preventDefault: false, // Prevent the default click behavior
    };

    // Create a ClickRedirect instance
    const clickRedirect = new ClickRedirect(
      sourceElement,
      targetElement,
      config
    );

    // Activate the ClickRedirect (add event listeners)
    clickRedirect.activate();
  });
}
